/* Bisou Tea redesign: reveal-on-scroll runtime.
   Port of the IntersectionObserver reveal in the project's bisou.js (same attributes and timings):
     data-reveal="<delay ms>"            fade + 28px rise, 900ms, ease-out (.22,.61,.36,1)
     data-reveal-kind="up|scale|left"    up (default) translateY(28px), scale 1.06 -> 1, left translateX(-28px)
     data-stagger (on a parent)          each direct child reveals with delay (index % 4) * 90ms (convenience, not in the mockups)
   Observer: threshold .12, rootMargin 0 0 -40px 0 (as in bisou.js).
   Differences from the mockup runtime (which sets inline styles after load, so content flashes):
   the hidden state is a CSS rule gated by html.bt-motion (bt-base.css); this file adds the gate before first paint
   (load it synchronously in <head>), toggles .bt-in on reveal, and adds .bt-done when the transition has finished so hover
   transforms on revealed elements are not delayed. Safety nets: hidden tab, print and a 1.5s check remove the gate.
   prefers-reduced-motion: everything shows instantly (CSS). API: window.BTMotion = { scan, reveal(el), revealAll() }. */
(function () {
  if (window.BTMotion) return;
  var root = document.documentElement;
  var hasIO = 'IntersectionObserver' in window;
  if (hasIO && !document.hidden) root.classList.add('bt-motion');

  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;

  function show(el) {
    if (el.classList.contains('bt-in')) return;
    el.classList.add('bt-in');
    var d = parseFloat(el.style.getPropertyValue('--bt-d')) || 0;
    setTimeout(function () { el.classList.add('bt-done'); }, d + 1000);
  }
  function inView(el) {
    var r = el.getBoundingClientRect(), h = window.innerHeight || 800;
    return r.top < h - 40 && r.bottom > 0;
  }
  function watch(el, delay) {
    el.setAttribute('data-bt-seen', '');
    if (delay) el.style.setProperty('--bt-d', delay + 'ms');
    if (!root.classList.contains('bt-motion') || !io || inView(el)) { show(el); return; }
    io.observe(el);
  }
  function scan() {
    document.querySelectorAll('[data-reveal]:not([data-bt-seen])').forEach(function (el) {
      watch(el, parseFloat(el.getAttribute('data-reveal')) || 0);
    });
    document.querySelectorAll('[data-stagger]').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) {
        if (!c.hasAttribute('data-bt-seen')) watch(c, (i % 4) * 90);
      });
    });
  }
  function reveal(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var sel = '[data-reveal],[data-stagger]>*';
    if (scope.matches && scope.matches(sel)) show(scope);
    scope.querySelectorAll(sel).forEach(function (el) { show(el); if (io) io.unobserve(el); });
  }
  function revealAll() {
    document.querySelectorAll('[data-reveal],[data-stagger]>*').forEach(function (el) { show(el); if (io) io.unobserve(el); });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    setTimeout(function () { queued = false; scan(); }, 0);
  }).observe(root, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('visibilitychange', function () { if (document.hidden) revealAll(); });
  window.addEventListener('beforeprint', function () { root.classList.remove('bt-motion'); revealAll(); });
  setTimeout(function () { if (document.hidden) { root.classList.remove('bt-motion'); revealAll(); } }, 1500);

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:reorder', scan);
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });

  window.BTMotion = { scan: scan, reveal: reveal, revealAll: revealAll };
  scan();
})();
